import React from 'react';
import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import {
  StaggerCss,
  getNinePointLayoutProperties,
  ContentSlideTitleSection,
} from '@mentimeter/question-modules-shared';
import { FlexibleText } from '@mentimeter/slides-presentation-ui/text/flexible-text';
import { Box } from '@mentimeter/ragnar-ui/box';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';

export function HeadingPresentation() {
  const {
    Utils: { fontOffset },
    useQuestion,
    useConfig,
  } = usePresentationContext();

  const {
    question,
    question_description: description,
    title_meta: meta,
    layout,
  } = useQuestion();
  const { enableAnimations } = useConfig();

  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(layout);

  const breakpoints = [
    { count: 300, offset: -2 },
    { count: 200, offset: -1 },
  ];

  const fullText = description
    ? question.length + description.length
    : question.length;
  const width = 30;
  const height = Math.round(fullText / width);
  const offset =
    fontOffset({
      height,
      width,
      breakpoints,
    }) + (layout?.font_size_offset ?? 0);

  return (
    <Box
      width="100%"
      height="70%"
      alignItems={alignItems}
      justifyContent={justifyContent}
    >
      <ContentSlideTitleSection
        question={question}
        title_meta={meta}
        layout={layout}
        textAlign={textAlign}
        alignItems={alignItems}
        enableAnimations={true}
        lineHeight="none"
        mb="space4"
      />
      {description && (
        <FlexibleText
          mb={0}
          textAlign={textAlign}
          fontOffset={offset}
          fontSize={5}
          color="text"
        >
          <StaggerCss index={2} enableAnimations={enableAnimations}>
            <MarkdownText
              source={description}
              disableLineBreaks={false}
              allowBlankLines
              allowHyperlinks
            />
          </StaggerCss>
        </FlexibleText>
      )}
    </Box>
  );
}
